import React, { useCallback } from 'react'

import { useTranslation } from 'react-i18next'

import { VehicleAutocomplete } from '@/components/common/VehicleAutocomplete'
import { Card, CardContent } from '@/components/ui/Card'
import { DateRangePicker } from '@/components/ui/DateRangePicker'
import { useVehicleAnalyticsStore } from '@/store/vehicleAnalytics.store'
import type { Vehicle } from '@/types/vehicle'

export function VehicleAnalyticsFilters() {
  const { t } = useTranslation()
  const { filters, setFilters } = useVehicleAnalyticsStore()

  const rangeValue = React.useMemo(() =>
    filters.from && filters.to ? { start: filters.from, end: filters.to } : null,
  [filters.from, filters.to])

  const handleDateRangeChange = useCallback((val: { start: string; end: string } | null) => {
    if (val) {
      setFilters({ from: val.start, to: val.end })
    } else {
      setFilters({ from: '', to: '' })
    }
  }, [setFilters])

  const handleVehicleChange = useCallback((v: Vehicle | null) => {
    setFilters({ vehicleID: v?.ID ?? '' })
  }, [setFilters])

  return (
    <Card>
      <CardContent className="p-2">
        <div className="flex gap-6 items-center flex-wrap">
          <div className="flex-1 min-w-72">
            <DateRangePicker
              value={rangeValue}
              onChange={handleDateRangeChange}
              variant={'secondary'}
            />
          </div>
          <div className="flex-1 w-64">
            <VehicleAutocomplete
              placeholder={t('warehouse.reports.vehicle_placeholder')}
              selectedId={filters.vehicleID}
              onSelectionChange={handleVehicleChange}
            />
          </div>
        </div>
      </CardContent>
    </Card>
  )
}
